module.exports = __webpack_public_path__ + "img/TradingView-img5.805cd90e.png";